import './css/PetProfile.scss'
import React, { useEffect, useState, ChangeEvent ,useRef} from 'react';
import { ReactComponent as UserIcon } from '@/assets/img/user-flat.svg';
import { useAddPet,useUploadPicture } from '../api/addPet';
import { useAuth } from '@/lib/auth';
import { ReactComponent as CameraIcon } from '@/assets/img/camera-icon.svg';
import PetsIcon from '@/assets/img/pets.png';
type Props = {
    name?:string;
    dob?:string
    uploadedImage1?: string;
    petsId?: any
  }
export const PetHeader = ({  petsId }: Props) => {
  const [uploadedImage, setUploadedImage] = useState<string>();
  const [name,setName] = useState("")
  const [dob,setDob] = useState("")
  const [uploadedImage1,setUploadedImage1] = useState("")
  const uploadPicture = useUploadPicture();
  const fileInputRef = useRef(null);
  const { user, refetchUser } = useAuth();

  useEffect(() => {
    if (user && user.pets && user.pets.length > 0) {
      const indexOfPet = user.pets.findIndex((ele)=>ele.id===petsId)
      const p = user.pets[indexOfPet];
      setName(p?.name)
      setDob(p?.dateOfBirth)
      setUploadedImage(p?.petsImageUrl);
      setUploadedImage1(p?.petsImageUrl)
    }
  }, [user,petsId,uploadedImage1]);

  const onFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files as FileList;
    setUploadedImage('')
    UploadPetProfilePic(selectedFiles?.[0]);
  };

  const UploadPetProfilePic =async(selectedFiles:any)=>{
    if(selectedFiles){
      const formData = new FormData();
      formData.append("file", selectedFiles);
      const response = await uploadPicture.mutateAsync({
        file:formData,
        petsId:petsId ? petsId : undefined
        });
        setUploadedImage(response ? response.imageUrl : '')
        refetchUser()
    }
  }
  
    const onUploadImageHandler = () => {
    if(fileInputRef && fileInputRef.current){
      (fileInputRef.current as any).click();
    }
  };
    return (
        <div className='row pets-details'>
            <div className="col-2 img-width">
              <div className="image-container">
              <div className="image-container">
          <span>
            {!uploadedImage && !uploadPicture.isLoading && uploadedImage1 &&(
               <>
               <div className='profile-img-div'>
              <img
                src={ uploadedImage1}
                className='profile-image pets-image'
              />
              
<div className='camera-img-div'>
              <CameraIcon className="camera-icon" onClick={onUploadImageHandler} />
              </div>
              </div>
              </>)}
            {uploadedImage && !uploadPicture.isLoading && uploadedImage1 ? (
              <>
              <div className='profile-img-div'>
              <img
                src={uploadedImage}
                className='profile-image pets-image'
              />
<div className='camera-img-div'>
              <CameraIcon className="camera-icon" onClick={onUploadImageHandler} />
              </div>
              </div>
              </>
            ) : (
              <>{!uploadPicture.isLoading && !uploadedImage1 &&  <><div className='profile-img-div'><img src={PetsIcon} className="profile-image pets-image" onClick={onUploadImageHandler} />  <div className='camera-img-div'>
              <CameraIcon className="camera-icon" onClick={onUploadImageHandler} />
              </div></div></>}</>
            )}
            <div className="middle" onClick={onUploadImageHandler}>
              <div className="text">Upload Pic</div>
            </div>
          </span>
        </div>
        {uploadPicture.isLoading  && <div className="image-container">
        <div className="loading-bar">Loading...</div>
        </div>}
          {" "}
          <div className="form-group">
            <input
              type="file"
              accept="image/*"
              onChange={onFileSelect}
              ref={fileInputRef}
              hidden
            />
          </div>
              </div>
            </div>
            <div className='col-10 pets-details'>
                <div className='name-text'>
                    {name}
                </div>
                <div className='date-text'>Birthday : {dob}</div>
            </div>
          </div>
    )
}